// Small, non-PII GA4 events. Booking/Skool clicks are not completed conversions.
export function trackFunnelEvent(name: string, params: Record<string, string> = {}) {
  if (typeof window.gtag !== 'function') return;
  const allowed = ['form_id', 'destination', 'page_path'];
  const safe = Object.fromEntries(Object.entries(params).filter(([key]) => allowed.includes(key)));
  window.gtag('event', name, { ...safe, transport_type: 'beacon' });
}
